/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsAffordabilityCalculatorAuthenticated204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsAffordabilityCalculatorAuthenticated505Schema = z.any();

export const optionsAffordabilityCalculatorAuthenticatedMutationResponseSchema = z.lazy(
  () => optionsAffordabilityCalculatorAuthenticated204Schema
);
